import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Badge } from 'react-bootstrap';
import { getUserData, saveUserData } from '../utils/util';
import { updateUsuarioPassword, updateUsuarioBasic } from '../services/configuracion/usuario-service';

const UserSettingsModal = ({ show, onHide }) => {
  const user = getUserData() || {};
  // Datos de usuario
  const [tipoDocumento, setTipoDocumento] = useState(user?.tip || '');
  const [numeroDocumento, setNumeroDocumento] = useState(user?.doc || '');
  const [nombreUsuarioState, setNombreUsuarioState] = useState(user?.nom || '');
  const [direccionCorreo, setDireccionCorreo] = useState(user?.eml || '');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [supportMsg, setSupportMsg] = useState('');
  const [supportSubject, setSupportSubject] = useState('');

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (!oldPassword || !newPassword || !confirmPassword) return alert('Complete los campos de contraseña');
    if (newPassword !== confirmPassword) return alert('La nueva contraseña y la confirmación no coinciden');
    const payload = {
      claveActual: oldPassword,
      claveNueva: newPassword,
      claveNuevaRe: confirmPassword,
    };
    try {
      await updateUsuarioPassword(payload);
      alert('Contraseña actualizada correctamente');
      setOldPassword(''); setNewPassword(''); setConfirmPassword('');
    } catch (error) {
      let msg = 'Error al actualizar la contraseña';
      if (error && error.response) msg = error.response.data?.error || error.response.data || msg;
      console.error('updateUsuarioPassword error', error);
      alert(msg);
    }
  };

  const handleSupportSubmit = (e) => {
    e.preventDefault();
    alert('Reportes Deshabilitados temporalmente');
    setSupportMsg(''); setSupportSubject('');
  };

  const handleSaveBasic = async () => {
    if (!tipoDocumento || !numeroDocumento || !nombreUsuarioState || !direccionCorreo) {
      return alert('Complete todos los campos antes de guardar');
    }
    const payload = {
      tipoDocumento: String(tipoDocumento),
      numDocumento: String(numeroDocumento),
      nombre: nombreUsuarioState,
      correo: direccionCorreo,
    };
    try {
      await updateUsuarioBasic(payload);
      const current = getUserData() || {};
      const updated = {
        ...current,
        tip: tipoDocumento,
        doc: numeroDocumento,
        nom: nombreUsuarioState,
        eml: direccionCorreo,
      };
      saveUserData(updated);
      alert('Datos de usuario actualizados correctamente');
    } catch (error) {
      let msg = 'Error al actualizar datos';
      if (error && error.response) msg = error.response.data?.error || error.response.data || msg;
      console.error('updateUsuarioBasic error', error);
      alert(msg);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Ajustes personales</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <h5 className="mb-1">Datos de Usuario</h5>
            <Form onSubmit={(e) => e.preventDefault()}>
              <Row>
                <Col md={4} className="mb-1">
                  <Form.Group>
                    <Form.Label>Tipo Docum</Form.Label>
                    <Form.Select size="sm" value={tipoDocumento} disabled onChange={(e) => setTipoDocumento(e.target.value)}>
                      <option value="1">DNI</option>
                      <option value="4">CE</option>
                      <option value="7">Pasaporte</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={8} className="mb-1">
                  <Form.Group>
                    <Form.Label>Número Documento</Form.Label>
                    <Form.Control size="sm" value={numeroDocumento} disabled onChange={(e) => setNumeroDocumento(e.target.value)} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-1">
                <Form.Label>Nombre Usuario</Form.Label>
                <Form.Control size="sm" value={nombreUsuarioState} onChange={(e) => setNombreUsuarioState(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Dirección de Correo</Form.Label>
                <Form.Control size="sm" type="email" value={direccionCorreo} onChange={(e) => setDireccionCorreo(e.target.value)} />
              </Form.Group>
                <div className="d-flex justify-content-end mt-1">
                <Button size="sm" variant="primary" onClick={handleSaveBasic}>Guardar</Button>
              </div>
            </Form>
            <hr className="my-2" />
            <h5 className="mb-1">Cambiar contraseña</h5>
            <Form onSubmit={handlePasswordChange}>
              <Form.Group className="mb-1">
                  <Form.Label>Contraseña actual</Form.Label>
                  <Form.Control size="sm" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Label>Nueva contraseña</Form.Label>
                  <Form.Control size="sm" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Label>Confirmar nueva contraseña</Form.Label>
                  <Form.Control size="sm" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                </Form.Group>
                <Button size="sm" variant="primary" type="submit" className="mt-1">Cambiar contraseña</Button>
            </Form>
          </Col>
          <Col md={6}>
            <h5 className="mb-1">Soporte rápido</h5>
            <Form onSubmit={handleSupportSubmit}>
              <Form.Group className="mb-1">
                <Form.Label>Asunto</Form.Label>
                <Form.Control size="sm" value={supportSubject} disabled required onChange={(e) => setSupportSubject(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Mensaje</Form.Label>
                <Form.Control size="sm" as="textarea" rows={4} disabled required value={supportMsg} onChange={(e) => setSupportMsg(e.target.value)} />
              </Form.Group>
              <Button size="sm" variant="secondary" disabled type="submit">Enviar reporte</Button>
            </Form>

            <hr />
            <h6>Información</h6>
            <p className="small text-muted">RUC: <strong>{user.ruc || '-'}</strong></p>
            <p className="small text-muted">Empresa: <strong>{user.emp || '-'}</strong></p>
            <p className="small text-muted">Usuario: <strong>{user.usr || '-'}</strong></p>
            
            <Badge bg="secondary">Soporte</Badge>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={onHide}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserSettingsModal;
